import LevelsModal from './Modals/LevelsModal';
import { useState, useEffect } from 'react';

const MobileLevels = ({ discount, plan }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    setIsDarkMode(mediaQuery.matches);

    const handleChange = (e) => setIsDarkMode(e.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);
  return (
    <>
      <div className='mr-8  mt-3 flex w-full'>
        <div className='sm:min-w-full mr-4 h-5 xl:h-7 bg-gray-200 rounded-full w-[80%] sm:w-[299px]'>
          {plan === 'Platinum' ? (
            <>
              {discount === 0 || discount === null ? (
                <div
                  className={`h-5 xl:h-7 items-center text-xs xl:text-sm  ${
                    isDarkMode
                      ? 'bg-[#292929] text-white'
                      : 'bg-yellow-gradient'
                  } rounded-full w-[0%] flex relative`}
                >
                  {/* <div
                    className={`hidden w-[35px] h-[35px] xl:w-[45px] xl:h-[45px] rounded-full  ${
                      isDarkMode
                        ? 'bg-[#292929] text-white'
                        : 'bg-yellow-gradient'
                    } border-4 border-white absolute right-0 items-center justify-center`}
                  >
                    <h1 className='font-bold'>00</h1>
                  </div> */}
                  <div>Platinum</div>
                </div>
              ) : discount > 0 && discount <= 21 ? (
                <div
                  className={`h-5 xl:h-7 items-center text-xs xl:text-sm    ${
                    isDarkMode
                      ? 'bg-[#292929] text-white'
                      : 'bg-yellow-gradient'
                  } rounded-full w-[50%] transform transition duration-500 ease-in-out justify-center flex relative`}
                >
                  {/* <div
                    className={` w-[35px] h-[35px] xl:w-[45px] xl:h-[45px] rounded-full  ${
                      isDarkMode
                        ? 'bg-[#292929] text-white'
                        : 'bg-yellow-gradient'
                    } border-4 border-white absolute right-0 items-center flex justify-center`}
                  >
                    <h1 className='font-bold'>01</h1>
                  </div> */}
                  <div>Platinum</div>
                </div>
              ) : discount > 21 && discount <= 25 ? (
                <div
                  className={`h-5 xl:h-7 items-center text-xs xl:text-sm  ${
                    isDarkMode
                      ? 'bg-[#292929] text-white'
                      : 'bg-yellow-gradient'
                  } rounded-full w-[75%] transform transition duration-500 ease-in-out justify-center flex relative`}
                >
                  {/* <div
                    className={` w-[35px] h-[35px] xl:w-[45px] xl:h-[45px] rounded-full  ${
                      isDarkMode
                        ? 'bg-[#292929] text-white'
                        : 'bg-yellow-gradient'
                    } border-4 border-white absolute right-0 items-center flex justify-center`}
                  >
                    <h1 className='font-bold'>02</h1>
                  </div> */}
                  <div>Platinum</div>
                </div>
              ) : discount > 25 && discount <= 29 ? (
                <div
                  className={`h-5 xl:h-7 items-center text-xs xl:text-sm ${
                    isDarkMode
                      ? 'bg-[#292929] text-white'
                      : 'bg-yellow-gradient'
                  } rounded-full w-[85%] transform transition duration-500 ease-in-out flex justify-center relative`}
                >
                  {/* <div
                    className={`w-[35px] h-[35px] xl:w-[45px] xl:h-[45px] rounded-full ${
                      isDarkMode
                        ? 'bg-[#292929] text-white'
                        : 'bg-yellow-gradient'
                    } border-4 border-white absolute right-0 items-center flex justify-center`}
                  >
                    <h1 className='font-bold'>03</h1>
                  </div> */}
                  <div>Platinum</div>
                </div>
              ) : (
                <div
                  className={`h-5 xl:h-7 items-center text-xs xl:text-sm ${
                    isDarkMode
                      ? 'bg-[#292929] text-white'
                      : 'bg-yellow-gradient'
                  } rounded-full w-[100%] justify-center flex relative`}
                >
                  {/* <div
                    className={`w-[35px] h-[35px] xl:w-[45px] xl:h-[45px] rounded-full ${
                      isDarkMode
                        ? 'bg-[#292929] text-white'
                        : 'bg-yellow-gradient'
                    } border-4 border-white absolute right-0 items-center flex justify-center`}
                  >
                    <h1 className='font-bold'>04</h1>
                  </div> */}
                  <div>Platinum</div>
                </div>
              )}
            </>
          ) : plan === 'Gold' ? (
            <>
              {discount === 0 || discount === null ? (
                <div
                  className={`h-5 xl:h-7 ${
                    isDarkMode
                      ? 'bg-[#292929] text-white'
                      : 'bg-yellow-gradient'
                  } rounded-full w-[0%] flex`}
                >
                  <div className='ml-3'>-</div>
                </div>
              ) : discount > 0 && discount <= 13 ? (
                <div
                  className={`h-5 xl:h-7 items-center text-xs xl:text-sm   ${
                    isDarkMode
                      ? 'bg-[#292929] text-white'
                      : 'bg-yellow-gradient'
                  } rounded-full w-[50%] justify-center flex relative`}
                >
                  {/* <div
                    className={`w-[35px] h-[35px] xl:w-[45px] xl:h-[45px] rounded-full ${
                      isDarkMode
                        ? 'bg-[#292929] text-white'
                        : 'bg-yellow-gradient'
                    } border-4 border-white absolute right-0 items-center flex justify-center`}
                  >
                    <h1 className='font-bold'>01</h1>
                  </div> */}
                  <div>Gold</div>
                </div>
              ) : discount > 13 && discount <= 17 ? (
                <div
                  className={`h-5 xl:h-7 items-center text-xs xl:text-sm ${
                    isDarkMode
                      ? 'bg-[#292929] text-white'
                      : 'bg-yellow-gradient'
                  } rounded-full w-[60%] justify-center flex relative`}
                >
                  {/* <div
                    className={`w-[35px] h-[35px] xl:w-[45px] xl:h-[45px] rounded-full ${
                      isDarkMode
                        ? 'bg-[#292929] text-white'
                        : 'bg-yellow-gradient'
                    } border-4 border-white absolute right-0 items-center flex justify-center`}
                  >
                    <h1 className='font-bold'>02</h1>
                  </div> */}
                  <div>Gold</div>
                </div>
              ) : discount > 17 && discount <= 21 ? (
                <div
                  className={`h-5 xl:h-7 items-center text-xs xl:text-sm   ${
                    isDarkMode
                      ? 'bg-[#292929] text-white'
                      : 'bg-yellow-gradient'
                  } rounded-full w-[75%] justify-center flex relative`}
                >
                  {/* <div
                    className={`w-[35px] h-[35px] xl:w-[45px] xl:h-[45px] rounded-full ${
                      isDarkMode
                        ? 'bg-[#292929] text-white'
                        : 'bg-yellow-gradient'
                    } border-4 border-white absolute right-0 items-center flex justify-center`}
                  >
                    <h1 className='font-bold'>03</h1>
                  </div> */}
                  <div>Gold</div>
                </div>
              ) : (
                <div
                  className={`h-5 xl:h-7 items-center text-xs xl:text-sm   ${
                    isDarkMode
                      ? 'bg-[#292929] text-white'
                      : 'bg-yellow-gradient'
                  } rounded-full w-[75%] justify-center flex relative`}
                >
                  {/* <div
                    className={`w-[35px] h-[35px] xl:w-[45px] xl:h-[45px] rounded-full ${
                      isDarkMode
                        ? 'bg-[#292929] text-white'
                        : 'bg-yellow-gradient'
                    } border-4 border-white absolute right-0 items-center flex justify-center`}
                  >
                    <h1 className='font-bold'>04</h1>
                  </div> */}
                  <div>Gold</div>
                </div>
              )}
            </>
          ) : plan == 'Old MSSP' ? (
            <div
              className={`h-5 xl:h-7 items-center text-xs xl:text-sm   bg-[#FEDD0B] dark:bg-[#292929] dark:text-white rounded-full w-full flex relative`}
            >
              <div className='ml-3'>MSSP</div>
            </div>
          ) : plan == null ? (
            <div className='ml-3'>-</div>
          ) : (
            <div className='ml-3'>{plan}</div>
          )}
        </div>
      </div>
      <div className='flex mx-2 pt-1 text-xs xl:text-sm'>
        <div className='flex text-center items-center justify-between sm:w-[344px]'>
          <LevelsModal plan={plan} discount={discount} />
          {/* <div className='flex items-center text-white'>
            <h1 className=' text-white ml-1 mr-[3px]'>Level </h1>
            {plan === 'Platinum' ? (
              <div>
                {' '}
                {discount === 0 || discount === null
                  ? '00'
                  : discount > 0 && discount <= 21
                  ? '01'
                  : discount > 21 && discount <= 25
                  ? '02'
                  : discount > 25 && discount <= 29
                  ? '03'
                  : '04'}
              </div>
            ) : plan === 'Gold' ? (
              <div>
                {discount === 0 || discount === null
                  ? '00'
                  : discount > 0 && discount <= 13
                  ? '01'
                  : discount > 13 && discount <= 17
                  ? '02'
                  : discount > 17 && discount <= 21
                  ? '03'
                  : '04'}
              </div>
            ) : plan == null ? (
              <div>-</div>
            ) : (
              <div>-</div>
            )}
          </div> */}
        </div>
      </div>
    </>
  );
};

export default MobileLevels;
